/* eslint-disable react/display-name */
import React from 'react'
import styled from 'styled-components'
import Theme, { MyTheme } from 'Components/common/Theme'
import { Col, Row, Space, Statistic } from 'antd'
import { ClockCircleOutlined, CreditCardOutlined, ShoppingCartOutlined } from '@ant-design/icons'
import { numberWithComma } from 'helpers/format'
import { SaleOrderSummary } from 'Store/saleorder-customer/types'

type Props = {
  detail?: SaleOrderSummary
}

const OrderSummary: React.FunctionComponent<Props> = props => {
  const { detail } = props
  const valStyle = {
    color: Theme.colors.black,
    fontFamily: Theme.fontFamily.regular,
    fontSize: Theme.typography.h4,
  }

  const orderBoxItem = (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <BoxWrapper style={{ backgroundColor: '#F2FEF0' }}>
          <div>
            <Space>
              <ShoppingCartOutlined />
              <Description>รายการสั่งซื้อทั้งหมด</Description>
            </Space>
            <Item>
              <Row gutter={[16, 16]}>
                <Col md={12} xs={24}>
                  <Statistic
                    title="จำนวนเงิน"
                    value={numberWithComma(detail?.total_sales || 0, true)}
                    suffix={<Unit>บาท</Unit>}
                    valueStyle={valStyle}
                  />
                </Col>
                <Col md={12} xs={24}>
                  <Statistic
                    valueStyle={valStyle}
                    title="จำนวนรายการ"
                    value={detail?.total_sale_items}
                    suffix={<Unit>รายการ</Unit>}
                    formatter={(val: any) => numberWithComma(val || 0)}
                  />
                </Col>
              </Row>
            </Item>
          </div>
        </BoxWrapper>
      </Col>
    </Row>
  )

  const creditBoxItem = (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <BoxWrapper style={{ backgroundColor: '#F1FBFE' }}>
          <div>
            <Space>
              <CreditCardOutlined />
              <Description>จำนวนเงินเครดิต</Description>
            </Space>
            <Item>
              <Row gutter={[16, 16]} justify="center">
                <Col md={12} xs={24}>
                  <Statistic
                    title="เครดิตที่ได้"
                    value={numberWithComma(detail?.credit_limit || 0, true)}
                    suffix={<Unit>บาท</Unit>}
                    valueStyle={valStyle}
                  />
                </Col>
                <Col md={12} xs={24}>
                  <Statistic
                    title="เครดิตคงเหลือ"
                    value={numberWithComma(detail?.credit_remain || 0, true)}
                    suffix={<Unit>บาท</Unit>}
                    valueStyle={valStyle}
                  />
                </Col>
              </Row>
            </Item>
          </div>
        </BoxWrapper>
      </Col>
    </Row>
  )

  const deptBoxItem = (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <BoxWrapper style={{ backgroundColor: '#FFF5F5' }}>
          <div>
            <Space>
              <ClockCircleOutlined />
              <Description>รายการสั่งซื้อที่รอชำระเงิน</Description>
            </Space>
            <Item>
              <Row gutter={[16, 16]}>
                <Col md={12} xs={24}>
                  <Statistic
                    title="จำนวนเงิน"
                    value={numberWithComma(detail?.total_waiting_payment || 0, true)}
                    suffix={<Unit>บาท</Unit>}
                    valueStyle={valStyle}
                  />
                </Col>
                <Col md={12} xs={24}>
                  <Statistic
                    valueStyle={valStyle}
                    title="จำนวนรายการ"
                    value={detail?.total_waiting_payment_items}
                    suffix={<Unit>รายการ</Unit>}
                    formatter={(val: any) => numberWithComma(val || 0)}
                  />
                </Col>
              </Row>
            </Item>
          </div>
        </BoxWrapper>
      </Col>
    </Row>
  )

  return (
    <BoxWrapper>
      <BoxTitle>ภาพรวมคู่ค้า/ ลูกค้า</BoxTitle>
      <Row gutter={[16, 16]}>
        <Col md={8} xs={24}>
          {creditBoxItem}
        </Col>
        <Col md={8} xs={24}>
          {orderBoxItem}
        </Col>
        <Col md={8} xs={24}>
          {deptBoxItem}
        </Col>
      </Row>
    </BoxWrapper>
  )
}

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 15px 10px;
  //border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  border: 1px solid #f0f0f0;
  margin-bottom: 10px;
  background-color:  ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`
const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body2};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
  margin-bottom: 20px;
`

const Legend = styled.span`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
`

const Description = styled.div`
  padding-left: 10px;
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
`

const Unit = styled(Legend)`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
`

const Item = styled.div`
  margin-top: 20px;
`

export default OrderSummary
